import { c as _c } from "react/compiler-runtime";
import styles from "./EffektSlider.module.scss";
import Draggable from "react-draggable";
import { RefObject, useEffect, useRef, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
export const EffektSlider: React.FC<{
  min: number;
  max: number;
  onChange: (val: number) => void;
  value: number;
}> = t0 => {
  const $ = _c(33);
  const {
    min,
    max,
    onChange,
    value
  } = t0;
  const [sliderWidth, setSliderWidth] = useState(0);
  const sliderRef = useRef(null);
  const handleRef = useRef(null);
  const scaledValue = Math.min((value - min) / (max - min), 1);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (sliderRef.current) {
        setSliderWidth(sliderRef.current.offsetWidth);
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const updateSizing = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => updateSizing();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      maxWait: 100
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const debouncedSizingUpdate = useDebouncedCallback(t2, 100, t3);
  let t4;
  let t5;
  if ($[3] !== debouncedSizingUpdate) {
    t4 = () => {
      debouncedSizingUpdate();
      window.addEventListener("resize", debouncedSizingUpdate);
      return () => window.removeEventListener("resize", debouncedSizingUpdate);
    };
    t5 = [debouncedSizingUpdate];
    $[3] = debouncedSizingUpdate;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  useEffect(t4, t5);
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className={styles.calculator__input__group__percentage_slider__labels}>{Array.from(Array(6)).map(_temp)}</div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== max || $[8] !== min || $[9] !== onChange || $[10] !== sliderWidth) {
    t7 = e => {
      const rect = sliderRef.current?.getBoundingClientRect();
      if (rect) {
        const x = Math.min(Math.max(0, (e.clientX || 0) - rect.left), rect.width);
        onChange(Math.round(x / sliderWidth * (min + (max - min))));
      }
    };
    $[7] = max;
    $[8] = min;
    $[9] = onChange;
    $[10] = sliderWidth;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className={styles.calculator__input__group__percentage_slider__bars}>{Array.from(Array(10)).map(_temp2)}</div>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const t9 = `polygon(0 0, ${scaledValue * 100}% 0, ${scaledValue * 100}% 100%, 0 100%)`;
  let t10;
  if ($[13] !== t9) {
    t10 = {
      clipPath: t9
    };
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = Array.from(Array(10)).map(_temp3);
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10) {
    t12 = <div className={styles.calculator__input__group__percentage_slider__track__fill} style={t10}>{t11}</div>;
    $[16] = t10;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== max || $[19] !== min || $[20] !== onChange || $[21] !== sliderWidth) {
    t13 = (e_0, data) => {
      onChange(Math.round(data.x / sliderWidth * (min + (max - min))));
    };
    $[18] = max;
    $[19] = min;
    $[20] = onChange;
    $[21] = sliderWidth;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const t14 = scaledValue * sliderWidth;
  let t15;
  if ($[23] !== t14) {
    t15 = {
      x: t14,
      y: 0
    };
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div ref={handleRef} className={styles.calculator__input__group__percentage_slider__handle} data-cy="slider-handle" />;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t13 || $[27] !== t15) {
    t17 = <Draggable axis="x" bounds="parent" onDrag={t13} position={t15} nodeRef={handleRef as RefObject<HTMLDivElement>}>{t16}</Draggable>;
    $[26] = t13;
    $[27] = t15;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t12 || $[30] !== t17 || $[31] !== t7) {
    t18 = <div className={styles.calculator__input__group__percentage_slider} ref={sliderRef} data-cy="slider-container">{t6}<div className={styles.calculator__input__group__percentage_slider__track} data-cy="slider-track" onClick={t7}>{t8}{t12}{t17}</div></div>;
    $[29] = t12;
    $[30] = t17;
    $[31] = t7;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  return t18;
};
function _temp(_, i) {
  return <div key={i} className={styles.calculator__input__group__percentage_slider__labels_label}>{i * 10}%</div>;
}
function _temp2(__0, i_0) {
  return <div key={i_0} className={styles.calculator__input__group__percentage_slider__bars__bar} />;
}
function _temp3(__1, i_1) {
  return <div key={i_1} className={styles.calculator__input__group__percentage_slider__track__fill__bar} />;
}